/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { put, select, takeLatest } from 'redux-saga/effects';

import { selectSettingsLoaded } from '@nebula/airglow-plugin-unified-shell';
import { INITED_SETTINGS } from '@nebula/airglow-plugin-unified-shell/dist/actions';

import {
  selectOrgValidationPluginSettings,
  selectSessionValidationPluginSettings,
  selectUserValidationPluginSettings
} from '../../common/selectors';
import { MODULE_LOADED } from '../actions';
import {
  orgValidationUpdates,
  sessionValidationUpdates,
  userValidationUpdates
} from '../data/prefabs';

export function* handleInitedSettings() {
  const settingsLoaded = yield select(selectSettingsLoaded);
  if (!settingsLoaded) {
    return;
  }

  const storedSessionSettings = yield select(selectSessionValidationPluginSettings);
  if (!R.isEmpty(storedSessionSettings)) {
    yield put(sessionValidationUpdates.changeAction(storedSessionSettings));
  }

  const storedUserSettings = yield select(selectUserValidationPluginSettings);
  if (!R.isEmpty(storedUserSettings)) {
    yield put(userValidationUpdates.changeAction(storedUserSettings));
  }

  const storedOrgSettings = yield select(selectOrgValidationPluginSettings);
  if (!R.isEmpty(storedOrgSettings)) {
    yield put(orgValidationUpdates.changeAction(storedOrgSettings));
  }
}

export function* watchInitedSettings() {
  yield takeLatest(INITED_SETTINGS, handleInitedSettings);
}

export function* watchSettingsModuleLoaded() {
  yield takeLatest(MODULE_LOADED, handleInitedSettings);
}
